import CryptoJS from "crypto-js"; 
import { createTransform } from "redux-persist";

const SECRET_KEY = "process.env.REDUX_ENC_KEY";
console.log("SECRET_KEY",SECRET_KEY)
// Create a transform for encrypting and decrypting the state
export const encryptTransform = createTransform(
  // Transform state before saving to localStorage (encrypt)
  (inboundState) => {
    return CryptoJS.AES.encrypt(
      JSON.stringify(inboundState),
      SECRET_KEY
    ).toString();
  },
  // Transform state when retrieving from localStorage (decrypt)
  (outboundState) => {
    const bytes = CryptoJS.AES.decrypt(outboundState, SECRET_KEY);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
  },
);